import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import StaffsTable from '../StaffsTable';

const CommonStaffList = ({
  handleViewDetail,
  toggleAddRecord,
  handleDelete,
  satffType,
  department,
  searchString,
}) => {
  return (
    <div>
      {' '}
      <ErrorBoundary>
        <StaffsTable
          handleViewDetail={handleViewDetail}
          toggleAddRecord={toggleAddRecord}
          handleDelete={handleDelete}
          searchString={searchString}
          satffType={satffType}
          department={department}
          op="IN"
        />
      </ErrorBoundary>
    </div>
  );
};

export default CommonStaffList;
